import { cmsApiClient } from '@/config/httpClients';
import type { SEORecursiveMapping } from '@/constants/page.constants';
import { type CMSSEOResponse, CMSSEOSchema } from '../common';

const getSEOContent = async (
  seoMapping: SEORecursiveMapping
): Promise<CMSSEOResponse | null> => {
  if (!seoMapping.slug) {
    return null;
  }
  const response = await cmsApiClient
    .get<{
      data: CMSSEOResponse[];
    }>(
      `collections/pages/entries?fields=seo_page_title,seo_description,seo_keyword&filter[slug:is]=${seoMapping.slug}`
    )
    .json();
  const parsedData = CMSSEOSchema.safeParse(response.data[0]);
  if (!parsedData.success) {
    console.error('ZOD ERROR ==>', parsedData);
  }

  const seoResponse = response.data[0];

  // Note: We just care about seo_page_title or seo_description, not seo_keywords
  const shouldRecurse =
    seoResponse.seo_page_title === null || seoResponse.seo_description === null;

  if (shouldRecurse && seoMapping.next !== null) {
    return getSEOContent(seoMapping.next);
  }

  return response.data[0];
};

export { getSEOContent };
